import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card pt-3 px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_recruit_list_item = _resolveComponent("recruit-list-item")!
  const _component_data_grid = _resolveComponent("data-grid")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", null, [
      _createElementVNode("h1", null, "Pending Recruitment")
    ], -1)),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_data_grid, {
              items: _ctx.pendingUsers,
              listView: ""
            }, {
              rows: _withCtx((rowProps) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowProps.pageItems, (item, index) => {
                  return (_openBlock(), _createBlock(_component_recruit_list_item, {
                    key: index,
                    recruit: item
                  }, null, 8, ["recruit"]))
                }), 128))
              ]),
              noItems: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "text-center pb-3" }, "No Pending Recruitment at this time", -1)
              ])),
              _: 1
            }, 8, ["items"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}